import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import { Fade } from "react-awesome-reveal";
import {ThemeProps} from "../../components/styles/themeprops";
import { useTranslation } from "react-i18next";

type SkillsProps = {
  children?: React.ReactNode;
  theme:ThemeProps
};

export default function Skills({
  children,
  theme,
}: SkillsProps) {
  const themeVar = {theme};
   const { t, i18n } = useTranslation();
  return (
    <div className="main" id="skills">
      <div className="skills-header-div">
        <Fade direction="up" duration={2000} damping={0.3} triggerOnce={true}>
          <h1 className="skills-header" style={{ color: themeVar.theme.text }}>
            {t("skills.whatido")}
          </h1>
        </Fade>
      </div>
      <SkillSection theme={themeVar.theme} />
    </div>
  );
}
